import Vue from 'vue'
import VueRouter from 'vue-router'
// store
import store from '@/store'
// Apollo
import { apolloClient } from '@/vue-apollo'
// Config environments
import { config } from '@/config'
// // Graphql
import insertView from '@/graphql/insertView.gql'
import verifyEditComany from '@/graphql/verifyEditCompany.gql'

import gql from 'graphql-tag'
// Auth
import AuthService from '@/services/auth'
const auth = new AuthService()

Vue.use(VueRouter)

const isAuthenticated = async (to, from, next) => {
  if (!await auth.isAuthenticated()) {
    next('/entrar')
    store.dispatch('saveRoute', { to, from })
  } else {
    let phone = localStorage.getItem('CognitoIdentityServiceProvider.' + config.userPoolWebClientId + '.LastAuthUser')
    let userAttributes = localStorage.getItem('CognitoIdentityServiceProvider.' + config.userPoolWebClientId + '.' + phone + '.userData')
    let userAttributesJSON = JSON.parse(userAttributes)
    let profile = userAttributesJSON.UserAttributes.find(attribute => attribute.Name === 'profile').Value

    if (to.fullPath.includes('detalhes') && profile !== 'admin') {
      let cnpj = to.fullPath.split('/')[2]
      let cnpjFormatted = ''

      if (cnpj.length === 5) cnpjFormatted = `${cnpj.substr(0, 2)}.${cnpj.substr(2, 3)}`
      else cnpjFormatted = cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5')

      if (from.name !== null) {
        await apolloClient.mutate({
          mutation: gql`${insertView}`,
          variables: {
            cnpj: cnpjFormatted
          }
        })
      }
    }

    if (to.fullPath.includes('editar-anuncio') && profile !== 'admin') {
      const cnpj = to.params.cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5')
      const userId = userAttributesJSON.Username
      const { data } = await apolloClient.mutate({
        mutation: gql`${verifyEditComany}`,
        variables: {
          cnpj,
          user_id: userId
        }
      })
      if (data.companies.length > 0) next()
      else next('/')
    } else {
      next()
    }
  }
}

const routes = [
  {
    path: '*',
    component: () => import('../views/PageNotFound/PageNotFound')
  },
  {
    path: '/',
    redirect: '/minha-area/meus-dados'
    // component: () => import('../views/Home/Home')
  },
  // {
  //   path: '/ver-mais',
  //   component: () => import('../views/SeeMore/SeeMore'),
  //   meta: {
  //     showNav: 'sub'
  //   }
  // },
  {
    path: '/proprietario',
    component: () => import('../views/Business/Business'),
    meta: {
      showNav: 'sub'
    }
  },
  {
    path: '/entrar',
    component: () => import('../views/Enter/Enter'),
    children: [
      {
        name: 'entrar',
        path: '',
        component: () => import('../views/Enter/components/SignIn'),
        meta: {
          showNav: 'hide',
          showFooter: 'hide'
        }
      },
      {
        name: 'confirme-seu-codigo',
        path: '/confirme-seu-codigo',
        component: () => import('../views/Enter/components/ConfirmCode'),
        meta: {
          showNav: 'hide',
          showFooter: 'hide'
        }
      },
      {
        name: 'registre-se',
        path: '/registre-se',
        component: () => import('../views/Enter/components/SignUp'),
        meta: {
          showNav: 'hide',
          showFooter: 'hide'
        }
      }
    ]
  },
  {
    path: '/minha-area',
    component: () => import('../views/ClientArea/ClientArea'),
    redirect: '/minha-area/meus-dados',
    children: [
      {
        path: 'meus-dados',
        component: () => import('../views/ClientArea/views/MyData/MyData'),
        beforeEnter: isAuthenticated,
        meta: {
          showFooter: 'hide'
        }
      },
      {
        path: 'meus-anuncios',
        component: () => import('../views/ClientArea/views/MyAdvert/MyAdvert'),
        beforeEnter: isAuthenticated,
        meta: {
          showFooter: 'hide'
        }
      },
      {
        path: 'favoritos',
        component: () => import('../views/ClientArea/views/Favorites/Favorites'),
        beforeEnter: isAuthenticated,
        meta: {
          showFooter: 'hide'
        }
      }
    ]
  },
  {
    path: '/minha-area/detalhes-anuncio/:cnpj',
    component: () => import ('../views/ClientArea/views/ViewCompany/ViewCompany'),
    meta: {
      showNav: 'hide',
      showFooter: 'hide'
    }
  },
  {
    path: '/cadastro-de-anuncio',
    component: () => import('../views/ClientArea/views/RegisterCompany/RegisterCompany'),
    beforeEnter: isAuthenticated,
    meta: {
      showNav: 'hide',
      showFooter: 'hide'
    }
  },
  {
    path: '/editar-anuncio/:cnpj',
    component: () => import('../views/ClientArea/views/EditCompany/EditCompany'),
    beforeEnter: isAuthenticated,
    meta: {
      showNav: 'hide',
      showFooter: 'hide'
    }
  },
  {
    name: 'oportunidades',
    path: '/oportunidades',
    component: () => import('../views/Opportunities/Opportunities'),
    beforeEnter: isAuthenticated,
    meta: {
      showInputSeach: 'show',
      showFooter: 'hide'
    }
  },
  {
    path: '/detalhes/:cnpj',
    component: () => import('../views/SimpleDetailCompany/SimpleDetailCompany'),
    beforeEnter: isAuthenticated
  },
  // {
  //   path: '/sobre-nos',
  //   component: () => import('../views/AboutUs/AboutUs')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    window.scrollTo(0, 0)
  }
})

router.afterEach((to, from) => {
  if (process.env.VUE_APP_INFOCRATICS_INTEGRARION) {
    if (window.analytics) {
      window.analytics.page()
    }
  }
})

export default router
